import { ICar } from '../..';

export const CARS_DSAUTOMOBILES: ICar[] = [
  {
    value: 'DsAutomobilesDs7Crossback',
    caption: 'DS Automobiles DS 7 Crossback',
    icon: 'ds-automobiles-ds7-crossback.jpg',
  },
];
